var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"card"},[_c('v-card-text',{staticClass:"pa-3"},[_c('line-chart',{attrs:{"data":_vm.data1,"xtitle":"Time","ytitle":"Order","dataset":{borderWidth: 3}}})],1)],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.data1))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa62f4d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/statistics/SiteViewStatistic.vue
// module id = null
// module chunks = 